import React, { FC } from 'react';
import HLPageTable from "../../../shared/components/table/HLPageTable";
import { ColDef } from "ag-grid-community";
import { getAllLessonsStudentFetch } from "../../../app/axios/lessonFetches";

import { useParams } from "react-router-dom";
import classes from "./StudentLessonsCard.module.scss";
import {
  LearningLanguage,
  LearningLanguageNameMap,
  LessonFormat,
  LessonFormatNameMap
} from "../../../shared/types/agreement";
import { LessonStudentView } from "../../../shared/types/lesson";
import { formatDateTimeForString } from "../../../shared/utils/dateUtils";


const columnDefs: ColDef<LessonStudentView>[] = [
    {
        field: 'lessonDate',
        headerName: 'Дата урока',
        valueFormatter: (params) => params.value && formatDateTimeForString(params.value)
    },
    {
        field: 'learningLanguage',
        headerName: 'Язык',
        valueFormatter: (params) => LearningLanguageNameMap[params.value as LearningLanguage],
    },
    {
        field: 'lessonFormat',
        headerName: 'Формат',
        valueFormatter: (params) => LessonFormatNameMap[params.value as LessonFormat],
    },
    {
        field: 'agreementName',
        headerName: 'Договор',
    },
    {
        field: 'canBeConducted',
        headerName: 'Можно проводить',
        valueFormatter: params => {
            if (params.data?.conducted) return '-'
            return params.value ? 'Да' : 'Нет'
        }
    },
    {field: 'conducted', headerName: 'Проведен', valueFormatter: params => params.value ? 'Да' : 'Нет'},
    {field: 'paid', headerName: 'Списан', valueFormatter: params => params.value ? 'Да' : 'Нет'},
    {field: 'attended', headerName: 'Посещен', valueFormatter: params => params.value ? 'Да' : 'Нет'},
    {field: 'teacherFullName', headerName: 'Учитель'},
];

const defaultColDef: ColDef<LessonStudentView> = {
    sortable: false,
    filter: false,
    resizable: true,
    flex: 1,
    minWidth: 100
};

const StudentLessonsCard: FC = () => {
    const {id: studentId} = useParams();

    const fetchData = async (pageRequest: any) => {
        // Добавляем фильтр по studentId
        const request = {
            ...pageRequest,
            filters: [
                ...(pageRequest.filters || []),
                {fieldName: 'studentId', operator: '=', fieldValue: studentId}
            ]
        };
        return getAllLessonsStudentFetch(request);
    };

    return (
        <div className={classes.contentContainer}>
            <HLPageTable
                title="Уроки ученика"
                columns={columnDefs}
                defaultColDef={defaultColDef}
                filterConfig={[]}
                actionButtons={[]}
                fetchData={fetchData}
                height={485}
            />
        </div>
    );
};

export default StudentLessonsCard;